module.exports = "/img/_/_/_/assets/images/creeper/battle/common//5.jpg?3d80f7cffa359c373a27adae11ac6663";